/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTTabs } from './tabs';
export type { KTTabsConfigInterface, KTTabsInterface } from './types';
